import Vue from 'vue'
import { repository, fullCollection } from '@/packages/vue-repository'

const endpoint = 'monitors'

export default ({ api }) => {
  return new Vue({
    mixins: [
      repository({ api, endpoint }),
      fullCollection({ api, endpoint })
    ],
    methods: {
      async setFavorite (id, favorite = true) {
        await this.update(id, { favorite })
      }
    }
  })
}